import { Play, Youtube } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const FeaturedVideo = () => {
  const { t } = useLang();
  return (
    <section id="stories" data-testid="featured-video-section" className="bg-coal py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <a
            href={t.featured.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="featured-video-link"
            className="group relative block overflow-hidden rounded-md border border-line"
          >
            <div className="relative aspect-video overflow-hidden">
              <img
                src={t.featured.image}
                alt={t.featured.title}
                loading="lazy"
                onError={(e) => {
                  if (e.currentTarget.src !== t.featured.imageFallback) e.currentTarget.src = t.featured.imageFallback;
                }}
                className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/10" />
            </div>

            <div className="absolute inset-0 flex items-center justify-center">
              <span className="flex h-20 w-20 items-center justify-center rounded-full bg-ember text-ink shadow-[0_0_60px_rgba(241,90,36,0.45)] transition-transform duration-500 group-hover:scale-110 md:h-24 md:w-24">
                <Play className="ml-1 h-9 w-9 fill-current" />
              </span>
            </div>

            <div className="absolute inset-x-0 bottom-0 p-6 md:p-12">
              <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-ember">{t.featured.eyebrow}</p>
              <h2 className="mt-3 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-cream md:text-5xl">
                {t.featured.title}
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-ash md:text-base">
                {t.featured.description}
              </p>
              <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-ember px-6 py-3 text-xs font-bold uppercase tracking-wider text-ember transition-colors duration-300 group-hover:bg-ember group-hover:text-ink">
                <Youtube className="h-4 w-4" />
                {t.featured.cta}
              </span>
            </div>
          </a>
        </Reveal>
      </div>
    </section>
  );
};
